export const PROMET_CONTACT_MAIL = "promet@promet-split.hr";
export const PROMET_CONTACT_PHONE = "021 407 999";
export const PROMET_WEB = "promet-split.hr";
export const SPLIT_COORDINATE = {
  lat: 43.509629747138476,
  lng: 16.437753353701297,
};

export const GOOGLE_MAPS_API_KEY = "AIzaSyAzEbNCjt3mfN6AdNLbA-Jzu2YfQW5yeOc";
export const USE_LEAFLET_MAPS = true // true - OpenStreetMap (Leaflet), false - GoogleMaps

export const TERMS_PDF_URL = {
  hr: "https://promet-split.hr/Portals/0/Datoteke/Važni dokumenti/Opći uvjeti.pdf",
  en: "https://promet-split.hr/Portals/0/Datoteke/Važni dokumenti/General terms.pdf",
};

export const COOKIE_POLICY_URL = {
  hr: "https://www.promet-split.hr/o-nama/pravila-privatnosti-i-opci-uvjeti-koristenja-mobilne-aplikacije/kolacici",
  en: "https://www.promet-split.hr/o-nama/pravila-privatnosti-i-opci-uvjeti-koristenja-mobilne-aplikacije/cookies",
};

export const PRIVACY_POLICY_URL = {
  hr: "https://promet-split.hr/o-nama/pravila-privatnosti-i-opci-uvjeti-koristenja-mobilne-aplikacije/pravila-privatnosti-koristenja-usluge-mobilne-aplikacije",
  en: "https://promet-split.hr/o-nama/pravila-privatnosti-i-opci-uvjeti-koristenja-mobilne-aplikacije/mobile-application-privacy-policy",
};

export const BUS_LINES_URL = {
  hr: "https://www.promet-split.hr/vozni-red",
  en: "https://www.promet-split.hr/en/timetables",
};

export const APP_STORE_URL =
  "https://apps.apple.com/app/promet-split/id1609058919";
export const GOOGLE_PLAY_URL =
  "https://play.google.com/store/apps/details?id=hr.prometsplit.mobile";

export const TRAFFIC_AREAS_CACHE_TTL = 604800000; // 7 days
export const E_WALLET_MINIMUM_TOPUP_VALUE = 1;
export const E_WALLET_MAXIMUM_TOPUP_VALUE = 25;
